import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { BaseCell } from "@similarweb/pro-logic-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, Combobox, IconButton, Textfield } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledDropdownButtonContainer = styled.div<{ $isOpen?: boolean }>`
    height: 24px;
    width: 136px;

    & .DropdownButton {
        height: 24px;
        ${setFontVariant("caption", colorsPalettes.carbon[400])};
        border: 1px solid ${colorsPalettes.midnight["50"]};
        padding-left: 8px;
        box-sizing: border-box;
        & .DropdownButton-text {
            text-indent: 8px;
            width: calc(100% - 24px);
        }
        & .DropdownButton--triangle {
            right: 8px;
            font-size: 3px;
            top: calc(50% - 1px);
        }

        ${({ $isOpen }) =>
            $isOpen &&
            css`
                box-shadow: 0px 3px 5px 0px #2a3e521f;
                border-color: ${colorsPalettes.blue[400]};
            `}
    }
`;

export const StyledDot = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    min-height: 8px;
    min-width: 8px;
    border-radius: 4px;
    background-color: ${(props) => props.color};
`;

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    justify-content: center;
    & > div {
        display: flex;
        justify-content: center;
    }
`;

export const StyledIconButton = styled(IconButton)`
    width: 24px !important;
    height: 24px !important;
    & ${SWReactIcons} > svg > path {
        fill: ${colorsPalettes.carbon[250]} !important;
    }
`;

export const StyledTagLabel = styled(Combobox.OptionLabel)`
    overflow-wrap: anywhere;
`;

export const StyledEditSection = styled(Stack)`
    border-top: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledColorCircle = styled.button<{ $color: string; $isSelected: boolean }>`
    width: 22px;
    height: 22px;
    min-width: 20px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
    border: 2px solid ${({ $isSelected, $color }) => ($isSelected ? $color : "transparent")};
    outline: ${({ $isSelected }) => ($isSelected ? `2px solid ${colorsPalettes.blue[400]}` : "none")};
    outline-offset: 1px;
    cursor: pointer;
    padding: 0;
    transition: transform 0.15s ease;

    &:hover {
        transform: scale(1.15);
    }
`;

export const StyledEditInput = styled(Textfield)`
    flex: 1;
    min-width: 0;

    & .input-container {
        height: 28px;
        border-color: ${colorsPalettes.carbon[200]};
        padding: 0 8px;
    }

    & input {
        ${setFontVariant("caption", colorsPalettes.carbon[500])};
    }
`;

export const StyledSaveButton = styled(Button)`
    height: 28px !important;
    min-width: 48px !important;
`;
